import React from 'react';

import { Link } from '@ergeon/core-components';
import { MicrophoneIcon } from '@ergeon/icons/hero/micro';

interface VoicemailMessageProps {
  durationStr?: string | null;
  recordingUrl?: string | null;
}

export const VoicemailMessage: React.FC<VoicemailMessageProps> = ({ durationStr, recordingUrl }) => (
  <div className="flex gap-2">
    <div className="flex items-center gap-1">
      <MicrophoneIcon className="size-4" />
      Voicemail - {durationStr || 'Unknown duration'}
    </div>
    {recordingUrl && (
      <Link href={recordingUrl} target="_blank">
        Recording available
      </Link>
    )}
  </div>
);
